import React, { createContext, useContext, useState, ReactNode } from "react"
import { SDoHQuestionnaireDialog } from "./SDoHQuestionnaireDialog"

interface SDoHModalContextType {
  isOpen: boolean
  showThankYou: boolean
  openModal: () => void
  closeModal: () => void
  setShowThankYou: (value: boolean) => void
}

const SDoHModalContext = createContext<SDoHModalContextType | undefined>(undefined)

export const SDoHModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showThankYou, setShowThankYou] = useState(false)

  const openModal = () => setIsOpen(true)

  const closeModal = () => {
    setIsOpen(false)
    setTimeout(() => setShowThankYou(false), 300)
  }

  return (
    <SDoHModalContext.Provider
      value={{
        isOpen,
        showThankYou,
        openModal,
        closeModal,
        setShowThankYou
      }}
    >
      {children}
      {isOpen && <SDoHQuestionnaireDialog open={isOpen} setOpen={(value) => (value ? openModal() : closeModal())} />}
    </SDoHModalContext.Provider>
  )
}

export const useSDoHModal = () => {
  const context = useContext(SDoHModalContext)
  if (context === undefined) {
    throw new Error("useSDoHModal must be used within a SDoHModalProvider")
  }
  return context
}
